import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { DocumentResponse } from '../models';

@Injectable({ providedIn: 'root' })
export class DocumentAdminService {
  private http = inject(HttpClient);
  private base = `${environment.apis.document}/admin/documents`;

  /** Sans paramètre `status` : combine PENDING_VALIDATION + ERROR côté backend ("En attente"). */
  getPendingDocuments(): Observable<DocumentResponse[]> {
    return this.http.get<DocumentResponse[]>(this.base);
  }

  /** ex: getDocumentsByStatus('VALIDATED') pour la liste des documents validés. */
  getDocumentsByStatus(status: string): Observable<DocumentResponse[]> {
    const params = new HttpParams().set('status', status);
    return this.http.get<DocumentResponse[]>(this.base, { params });
  }

  getDocumentUrl(docId: string): Observable<string> {
    return this.http.get(`${this.base}/${docId}/url`, { responseType: 'text' });
  }

  validateDocument(docId: string): Observable<void> {
    return this.http.patch<void>(`${this.base}/${docId}/validate`, {});
  }

  rejectDocument(docId: string, reason: string): Observable<void> {
    return this.http.patch<void>(`${this.base}/${docId}/reject`, { reason });
  }
}
